import { render } from "./NumberToWord.vue?vue&type=template&id=41664fda"
import script from "./NumberToWord.vue?vue&type=script&lang=js"
export * from "./NumberToWord.vue?vue&type=script&lang=js"

import "./NumberToWord.vue?vue&type=style&index=0&id=41664fda&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__